import Index from "./index.vue"

export default [
  {
    path: "general",
    name: "settings-general",
    component: Index,
    title: "General",
  },
]
